"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CommunicationSnippet;
(function (CommunicationSnippet) {
    CommunicationSnippet[CommunicationSnippet["ResultsTable"] = 0] = "ResultsTable";
})(CommunicationSnippet = exports.CommunicationSnippet || (exports.CommunicationSnippet = {}));
//# sourceMappingURL=CommunicationSnippet.js.map